import styled, { css } from 'styled-components';
import theme from 'styled-theming';

import * as Colors from '../../attrs/colors';
import MQ from '../../attrs/mq';

const ContainerType = theme('type', {
  standard: css`
    border-radius: 0;
  `,
  advanced: css`
    border-radius: 10px;
  `,
  professional: css`
    border-radius: 16px;
  `,
});

export const Container = styled.span`
  display: inline-block;
  width: 24px;
  height: 24px;
  border: 1px solid ${Colors.BLACK};
  margin-bottom: 1rem;

  ${ContainerType};

  ${MQ.md`
    width: 32px;
    height: 32px;
    margin-bottom: 1.5rem;
  `}
`;
